import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLocationsResponse, ILocation, ILocationVehicleCountResponse, ILocationVehicleCountsResponse } from "../models/Location";

export default function useLocations() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const locations = useQuery({
    queryKey: ["locations"],
    queryFn: () => get<IAllLocationsResponse>("/location"),
    staleTime: 1000 * 60 * 10, //10 minutes
  });

  const vehicleCounts = useQuery({
    queryKey: ["location-vehicle-counts"],
    queryFn: () => get<ILocationVehicleCountsResponse>("/location/vehicle-counts"),
    staleTime: 1000 * 60 * 2, //2 minutes
  });

  const vehicleCount = (locationId: string) =>
    get<ILocationVehicleCountResponse>(`/location/${locationId}/vehicle-count`);

  const create = useMutation(
    (location: ILocation) => post("/location", location),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["locations"]);
        queryClient.invalidateQueries(["location-vehicle-counts"]);
      },
    }
  );

  const update = useMutation(
    (location: ILocation) => put(`/location/${location.id}`, location),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["locations"]);
        queryClient.invalidateQueries(["location-vehicle-counts"]);
      },
    }
  );

  const remove = useMutation(
    (locationId: string) => del(`/location/${locationId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["locations"]);
        queryClient.invalidateQueries(["location-vehicle-counts"]);
      },
    }
  );

  return {
    locations,
    vehicleCounts,
    vehicleCount,
    create,
    update,
    remove,
  };
}
